import { Component, OnInit } from "@angular/core";
import { ProductTile } from "../models/product-tile.model";
import { ActivatedRoute, Router } from "@angular/router";
import { CollectionService } from "../ApplicationServices/CollectionService";
import { ProductDetailsService } from '../ApplicationServices/ProductDetailsService';
import { ItemModifierService } from "src/app/ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";


@Component({
  selector: 'app-searchproducts',
  templateUrl: './searchproducts.component.html',
  styleUrls: ['./searchproducts.component.scss']
})

//   SearchproductsComponent

export class SearchproductsComponent implements OnInit {


  CK3: boolean = false;
  CK6: boolean = false;
  CK9: boolean = false;
  CK12: boolean = false;
  CK15: boolean = false;
  CK18: boolean = false;
  CK21: boolean = false;
  CK24: boolean = false;

  CK27: boolean = false;
  CK30: boolean = false;
  CK33: boolean = false;
  CK36: boolean = false;

  CK39: boolean = false;
  CK42: boolean = false;
  CK45: boolean = false;
  CK48: boolean = false;

  CK51: boolean = false;
  CK54: boolean = false;
  CK57: boolean = false;
  CK60: boolean = false;

  CK63: boolean = false;
  CK66: boolean = false;
  CK69: boolean = false;
  CK72: boolean = false;

  CK75: boolean = false;
  CK78: boolean = false;
  CK81: boolean = false;
  CK84: boolean = false;

  CK87: boolean = false;
  CK90: boolean = false;
  CK93: boolean = false;
  CK96: boolean = false;

  CK99: boolean = false;
  CK102: boolean = false;
  CK105: boolean = false;
  CK108: boolean = false;

  CK111: boolean = false;
  CK114: boolean = false;
  CK117: boolean = false;
  CK120: boolean = false;

  CK123: boolean = false;
  CK126: boolean = false;
  CK129: boolean = false;
  CK132: boolean = false;

  CK135: boolean = false;
  CK138: boolean = false;
  CK141: boolean = false;
  CK144: boolean = false;

  CK147: boolean = false;
  CK150: boolean = false;
  CK153: boolean = false;
  CK156: boolean = false;

  CK159: boolean = false;
  CK162: boolean = false;
  CK165: boolean = false;
  CK168: boolean = false;
  CK171: boolean = false;
  CK174: boolean = false;


  CK177: boolean = false;
  CK180: boolean = false;
  CK183: boolean = false;
  CK186: boolean = false;
  CK189: boolean = false;
  CK192: boolean = false;

  CK195: boolean = false;
  CK198: boolean = false;
  CK201: boolean = false;
  CK204: boolean = false;
  


  //CAP: boolean = true;
  CAP: boolean = true;

  productTileList: ProductTile[] = [];
  productList: ProductTile[] = [];
  collectionServ: CollectionService = null;
  productListAvailable = false;
  private sub: any;
  currentQuickView:ProductTile;
  showQuickView:boolean=false;
  detailedService: ProductDetailsService;

  CATEGORY :String=null;
  SUBCATEGORY :String=null;

  _SKUCODE_ :String=null;


  total:0;
  range='0'
  constructor(

    private route: ActivatedRoute,
    private router: Router,
    private collectionService: CollectionService,
    private detailService: ProductDetailsService,
    private itemModifierService: ItemModifierService,
    private infoStore: UserInfoStore

  ) {

    this.collectionServ = collectionService;
    this.detailedService = detailService;

  }

  ngOnInit() {


    this.CK3= false;
    this.CK6= false;
    this.CK9= false;
    this.CK12= false;
    this.CK15= false;
    this.CK18= false;
    this.CK21= false;
    this.CK24= false;
  
    this.CK27= false;
    this.CK30= false;
    this.CK33= false;
    this.CK36= false;
  
    this.CK39= false;
    this.CK42= false;
    this.CK45= false;
    this.CK48= false;
  
    this.CK51= false;
    this.CK54= false;
    this.CK57= false;
    this.CK60= false;
  
    this.CK63= false;
    this.CK66= false;
    this.CK69= false;
    this.CK72= false;
  
    this.CK75= false;
    this.CK78= false;
    this.CK81= false;
    this.CK84= false;
  
    this.CK87= false;
    this.CK90= false;
    this.CK93= false;
    this.CK96= false;
  
    this.CK99= false;
    this.CK102= false;
    this.CK105= false;
    this.CK108= false;
  
    this.CK111= false;
    this.CK114= false;
    this.CK117= false;
    this.CK120= false;
  
    this.CK123= false;
    this.CK126= false;
    this.CK129= false;
    this.CK132= false;
  
    this.CK135= false;
    this.CK138= false;
    this.CK141= false;
    this.CK144= false;
  
    this.CK147= false;
    this.CK150= false;
    this.CK153= false;
    this.CK156= false;
  
    this.CK159= false;
    this.CK162= false;
    this.CK165= false;
    this.CK168= false;
    this.CK171= false;
    this.CK174= false;
  
  
    this.CK177= false;
    this.CK180= false;
    this.CK183= false;
    this.CK186= false;
    this.CK189= false;
    this.CK192= false;
  
    this.CK195= false;
    this.CK198= false;
    this.CK201= false;
    this.CK204= false;



      this.CAP=false;

      this.sub = this.route.params.subscribe((params) => {
      this.productListAvailable = false;
      var arg = params["itemCategory"];
      const itemName = arg.split("&")[1];
      const itemCategory = arg.split("&")[0];
      switch (itemCategory) {

        case "Men":
          this.collectionServ
            .getAllMENSCOLLECTION_NAMEData(itemName)
            .subscribe((data: any) => this.manageRes(data));
            this.CATEGORY="Mens Collections";
            this.SUBCATEGORY=itemName;
          break;
        case "Women":
          this.collectionServ
            .getAllWOMENSCOLLECTION_NAMEData(itemName)
            .subscribe((data: any) => this.manageRes(data));
             this.CATEGORY="Womens Collections";
             this.SUBCATEGORY=itemName;
          break;
        case "Uni":
          this.collectionServ
            .getAllUNISEXCOLLECTION_NAMEData(itemName)
            .subscribe((data: any) => this.manageRes(data));
            this.CATEGORY="Unisex Collections";
            this.SUBCATEGORY=itemName;
          break;
        case "Others":
          this.collectionServ
            .getAllOTHERSCOLLECTION_NAMEData(itemName)
            .subscribe((data: any) => this.manageRes(data));
            this.CATEGORY="Others Collections";
            this.SUBCATEGORY=itemName;
          break;
          
        default:
          break;
      }
    });


    if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

      this.infoStore.setCartInfo([]);
      sessionStorage.clear();
      this.infoStore.setInfo({});

     alert("Session Expired , Please Login  !!");
     this.router.navigateByUrl("login");

     }



  }


  addToCart1() {

    //  if( this._Status_=='QV' ){

    //   this._SKUCODE_=this._SKUCODEQ_;

    //  }
    //  else  if( this._Status_=='GE' )
    //  {

    //   this._SKUCODE_=this._SKUCODEG_;

    //  }

    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        ApplicationItemCategoryId: 4,
        OrderStatusID: 2,
        OrderShippingCategoryID: 0,
        OrderPaymentTypeId: 0,
        PackingId: 0,
        TrackId: 0,
        SKUCode: this._SKUCODE_,
        Qty: 1,
        CreatedBy: 55,
        OperationType: "insert",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Saved") {
            alert("Add To Cart Successfully !");
            this.getCartInfo();
          }
        }
      });
    } else {
      alert("Please Login !!");
      this.router.navigateByUrl("login");
    }
  }


  getCartInfo() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    } else {
      this.infoStore.setCartInfo([]);
    }
  }







  manageRes(data: any) {

    this.productList = [];
    this.total=data.length
    this.range=`1 - ${data.length}`
    for (let index = 0; index < data.length; index++) {
      let prod = new ProductTile();
      prod=data[index];
      // prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
      prod.HotLabel = data[index].PrimaryTagName;
      // prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";
      prod.ProductTileImgURL1 = data[index].img1; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductTileImgURL2 = data[index].img2; //"../../../assets/styles/images/books/1.jpg";
      prod.ProductBlockImgURL = data[index].img3; //"../../../assets/styles/images/product/2.jpg";
      prod.ProductName = data[index].ItemName; //"robin parrish";
      prod.ProductURL = "#/single-product";
      prod.ItemId = data[index].ItemId;
      prod.SKUCode= data[index].SKUCode;
      this._SKUCODE_= data[index].SKUCode;
      prod.ProductDescription =
      "Designed for simplicity and made from high quality materials."+
      "Its sleek geometry and material combinations creates a modern look"+
      "- the ultimate look you desire for.";

      prod.CollectionName = "PRODUCT";

      if(  data[index].PriceCaption == null || data[index].PriceCaption == "" )
      {

        // this.CAP=true;

        prod.CurrentPrize = "Rs."+" "+  data[index].StrikePrice; //"$35.00";
        prod.OldPrize ="Rs."+" "+  data[index].MaxRetailPrice; //"$55.00";          
            

      }
      else
      {

          // this.CAP=false;
         //prod.CurrentPrize ="Rs."+" "+ data[index].StrikePrice; //"$35.00";
        //prod.OldPrize = "Rs."+" "+ data[index].MaxRetailPrice; //"$55.00";          
        
          
        prod.CurrentPrize = data[index].StrikePrice; //"$35.00";
        prod.OldPrize = ""; //"$55.00"; 
    

      }



      // if( this.CATEGORY=="Others" ){
      //   prod.CollectionName = "Others";
      // }
      // else if( this.CATEGORY=="Uni" ){
      //   prod.CollectionName = "Uni";
      // }
      // else if( this.CATEGORY=="Women" ){
      //   prod.CollectionName = "Women";
      // }
      // else if( this.CATEGORY=="Men" ){
      //   prod.CollectionName = "Men";
      // }


      this.productList.push(prod);

    }

    this.productListAvailable = true;

    
    if(   data.length > 0  &&   data.length <= 3 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= false;
       this.CK12= false;
       this.CK15= false;
       this.CK18= false;
       this.CK21= false;
       this.CK24= false;
     
       this.CK27= false;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   data.length > 3  &&  data.length <= 6 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= false;
       this.CK15= false;
       this.CK18= false;
       this.CK21= false;
       this.CK24= false;
     
       this.CK27= false;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
       
    else if(   data.length > 6  &&   data.length <= 9 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= false;
       this.CK18= false;
       this.CK21= false;
       this.CK24= false;
     
       this.CK27= false;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   data.length > 9  &&   data.length <= 12 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= false;
       this.CK21= false;
       this.CK24= false;
     
       this.CK27= false;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   this.total > 12  &&   this.total <= 15 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= false;
       this.CK24= false;
     
       this.CK27= false;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   this.total > 15  &&   this.total <= 18  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= false;
     
       this.CK27= false;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
        
    else if(   this.total > 18  &&   this.total <= 21  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= false;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   this.total > 21  &&   this.total <= 24  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= false;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
         
    else if(   this.total > 24  &&   this.total <= 27  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= false;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
        
    else if(   this.total > 27  &&   this.total <= 30 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= false;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
        
    else if(   this.total > 30  &&   this.total <= 33 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= false;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
       
    else if(   this.total > 33  &&   this.total <= 36 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= false;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
        
    else if(   this.total > 36  &&   this.total <= 39 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= false;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
          
    else if(   this.total > 39  &&   this.total <= 42 )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= false;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }


    
         
    else if(   this.total > 42  &&   this.total <= 45  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= false;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
         
    else if(   this.total > 45  &&   this.total <= 48  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= false;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
          
    else if(   this.total > 48  &&   this.total <= 51  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= false;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
         
    else if(   this.total > 51  &&   this.total <= 54  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= false;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
         
    else if(   this.total > 54  &&   this.total <= 57  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= false;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
         
    else if(   this.total > 57  &&   this.total <= 60  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= false;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
          
    else if(   this.total > 60  &&   this.total <= 63  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= false;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
         
    else if(   this.total > 63  &&   this.total <= 66  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= false;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   this.total > 66  &&   this.total <= 69  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= false;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
     
    else if(   this.total > 69  &&   this.total <= 72  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= false;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
     
    else if(   this.total > 72  &&   this.total <= 75  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= false;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
     
    else if(   this.total > 75  &&   this.total <= 78  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= false;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
     
    else if(   this.total > 78  &&   this.total <= 81  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= false;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 81  &&   this.total <= 84  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= false;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 84  &&   this.total <= 87  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= false;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
     
    else if(   this.total > 87  &&   this.total <= 90  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= false;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }


    else if(   this.total > 90  &&   this.total <= 93  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= false;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

    else if(   this.total > 93  &&   this.total <= 96  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= false;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

    else if(   this.total > 96  &&   this.total <= 99  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= false;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 99  &&   this.total <= 102  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= false;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
       
    else if(   this.total > 102  &&   this.total <= 105  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= false;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
       
    else if(   this.total > 105  &&   this.total <= 108  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= false;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
       
    else if(   this.total > 108  &&   this.total <= 111  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= false;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   this.total > 111  &&   this.total <= 114  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= false;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 114  &&   this.total <= 117  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= false;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 117  &&   this.total <= 120  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= false;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 120  &&   this.total <= 123  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= false;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 123  &&   this.total <= 126  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= false;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
     
    else if(   this.total > 126  &&   this.total <= 129  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= false;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }   
    
    else if(   this.total > 129  &&   this.total <= 132  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= false;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }   
    
    else if(   this.total > 132  &&   this.total <= 135  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= false;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
     
    else if(   this.total > 135  &&   this.total <= 138  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= false;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }   
     
    else if(   this.total > 138  &&   this.total <= 141  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= false;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   this.total > 141  &&   this.total <= 144  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= false;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
       
    else if(   this.total > 144  &&   this.total <= 147  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= false;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

       
    else if(   this.total > 147  &&   this.total <= 150  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= false;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

     
    else if(   this.total > 150  &&   this.total <= 153  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= false;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

    
    else if(   this.total > 153  &&   this.total <= 156  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= false;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

    
    else if(   this.total > 156  &&   this.total <= 159  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= false;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
      
    else if(   this.total > 159  &&   this.total <= 162  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= false;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
   
    
    else if(   this.total > 162  &&   this.total <= 165  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= false;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 165  &&   this.total <= 168  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= false;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }
    
    else if(   this.total > 168  &&   this.total <= 171  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= false;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

      
    else if(   this.total > 171  &&   this.total <= 174  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= false;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

      
    else if(   this.total > 174  &&   this.total <= 177  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= false;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

     
    else if(   this.total > 177  &&   this.total <= 180  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= false;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

      
    else if(   this.total > 180  &&   this.total <= 183  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= true;
       this.CK189= false;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

     
    else if(   this.total > 183  &&   this.total <= 186  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= true;
       this.CK189= true;
       this.CK192= false;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

    
    else if(   this.total > 186  &&   this.total <= 189  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= true;
       this.CK189= true;
       this.CK192= true;
     
       this.CK195= false;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

      
    else if(   this.total > 189  &&   this.total <= 192  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= true;
       this.CK189= true;
       this.CK192= true;
     
       this.CK195= true;
       this.CK198= false;
       this.CK201= false;
       this.CK204= false;



    }

   
    else if(   this.total > 192  &&   this.total <= 195  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= true;
       this.CK189= true;
       this.CK192= true;
     
       this.CK195= true;
       this.CK198= true;
       this.CK201= false;
       this.CK204= false;



    }

    
    else if(   this.total > 195  &&   this.total <= 198  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= true;
       this.CK189= true;
       this.CK192= true;
     
       this.CK195= true;
       this.CK198= true;
       this.CK201= true;
       this.CK204= false;



    }


      
    else if(   this.total > 198  &&   this.total <= 201  )
    {

       
       this.CK3= true;
       this.CK6= true;
       this.CK9= true;
       this.CK12= true;
       this.CK15= true;
       this.CK18= true;
       this.CK21= true;
       this.CK24= true;
     
       this.CK27= true;
       this.CK30= true;
       this.CK33= true;
       this.CK36= true;
     
       this.CK39= true;
       this.CK42= true;
       this.CK45= true;
       this.CK48= true;
     
       this.CK51= true;
       this.CK54= true;
       this.CK57= true;
       this.CK60= true;
     
       this.CK63= true;
       this.CK66= true;
       this.CK69= true;
       this.CK72= true;
     
       this.CK75= true;
       this.CK78= true;
       this.CK81= true;
       this.CK84= true;
     
       this.CK87= true;
       this.CK90= true;
       this.CK93= true;
       this.CK96= true;
     
       this.CK99= true;
       this.CK102= true;
       this.CK105= true;
       this.CK108= true;
     
       this.CK111= true;
       this.CK114= true;
       this.CK117= true;
       this.CK120= true;
     
       this.CK123= true;
       this.CK126= true;
       this.CK129= true;
       this.CK132= true;
     
       this.CK135= true;
       this.CK138= true;
       this.CK141= true;
       this.CK144= true;
     
       this.CK147= true;
       this.CK150= true;
       this.CK153= true;
       this.CK156= true;
     
       this.CK159= true;
       this.CK162= true;
       this.CK165= true;
       this.CK168= true;
       this.CK171= true;
       this.CK174= true;
     
     
       this.CK177= true;
       this.CK180= true;
       this.CK183= true;
       this.CK186= true;
       this.CK189= true;
       this.CK192= true;
     
       this.CK195= true;
       this.CK198= true;
       this.CK201= true;
       this.CK204= true;



    }






  }



  ngOnDestroy() {
    if(this.sub){
    this.sub.unsubscribe();}
  }



  // quickView(sku){
  //   this.showQuickView=false;

  //   this.detailedService
  //     .getProductDetailsBySKUData(sku)
  //     .subscribe((data: any) => this.manageRes2(data));



  //  }



  //  manageRes2(data){

  //   this.currentQuickView = data[0];
  //   this.currentQuickView.CurrentPrize ="Rs."+ " "+ data[0].StrikePrice;
  //   this.currentQuickView.HotLabel = "NEW";
  //   this.currentQuickView.OldPrize = "Rs."+ " "+ data[0].MaxRetailPrice;
  //   this.currentQuickView.ProductTileImgURL1 = data[0].img1;
  //   this.currentQuickView.ProductTileImgURL2 = data[0].img2;
  //   this.currentQuickView.ProductBlockImgURL = data[0].img3;
  //   this.currentQuickView.ProductName = data[0].ItemName;
  //   this.currentQuickView.ProductURL = "#/single-product";
  //   this.currentQuickView.ItemId = data[0].ItemId;
  //   this.currentQuickView.SKUCode = data[0].SKUCode;
  //   this.currentQuickView.ImageList = data[0].ImgCollection.split("#");
  //   this.currentQuickView.ProductDescription =

  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla "+
  //     "augue nec est tristique auctor. Donec non est at libero vulputate rutrum."+
  //     "Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate "+
  //     "adipiscing cursus eu, suscipit id nulla.";

  //   this.showQuickView=true

  //  }




quickView(collectionName) {
  this.showQuickView = false;
  const skus = collectionName.split("&")[0];
  this._SKUCODE_=collectionName.split("&")[0];
  const collection = collectionName.split("&")[1];
  this.currentQuickView = null;
  switch (collection) {
    case "PRODUCT":
      this.productList.forEach((item) => {
          if (item.SKUCode == skus) {
            this.currentQuickView = item;
            this.showQuickView = true;
          }
      });
      break;

    default:
      break;

  }

}



}

